'use strict';

import angular from 'angular';
import ShowController from './show.controller';

export default angular.module('updateServerApp.carousel.show', [])
  .controller('CarouselShowController', ShowController)
  .name;



// WEBPACK FOOTER //
// ./client/app/carousel/show/index.js